import {HazmatSourceCd} from '../';
import {EnumHelper} from './enum-helper';

export class HazmatSourceCdHelperEnumHelperClass extends EnumHelper {

  public constructor() {
  	super();
    for ( const obj in HazmatSourceCd ) {
      this._values.push(HazmatSourceCd[obj]);
      this._keys.push(obj);
    }
  }

  public toEnum(value: string): HazmatSourceCd {

    for ( const obj in HazmatSourceCd ) {
      if (HazmatSourceCd[obj] === value){
        return HazmatSourceCd[obj] as HazmatSourceCd;
      }
    }
  }
}

const HazmatSourceCdHelper = new HazmatSourceCdHelperEnumHelperClass();
export default HazmatSourceCdHelper;
